import React from 'react';
import moment from 'moment';
import classes from './Modals.css';

const TransferTransaction = (props) => {
    const dates = props.dateRange.replace('?dateFrom=', '').replace('dateTo=', '').split('&');

    return (
    <div className={classes.container}>
        <h2 className={classes.heading}>{`${props.modalType} Transactions`}</h2>
        <div className={classes.content}>
            Do you want to {props.modalType} all transactions between 
            <span className={classes.spanItem}> {moment.unix(dates[0]).utc().format('DD MMM YY')} </span> and 
            <span className={classes.spanItem}> {moment.unix(dates[1]).utc().format('DD MMM YY')} </span> for 
            <span className={classes.spanItem}> {props.account.label}</span>
        </div>
        <hr />
        <div>
            <button type="button" onClick={() => props.onPost(props.account)} className={[classes.btn, classes.btnPrimary].join(' ')}>{props.modalType} Transactions</button>
            <button type="button" onClick={props.onClose} className={[classes.btn, classes.btnDefault].join(' ')}>Cancel</button>
        </div>
    </div>
    );
}

export default TransferTransaction;



// WEBPACK FOOTER //
// ./src/components/Modals/TransferTransactions.js